<template>
  <!--头图-->
  <div id="headerTop">
    <div v-if="slides.length==0"  style="text-align: center;">
      <img :src="banner" v-lazy="banner" alt="">
    </div>
    <div v-if="slides.length>0">
      <swiper :slides="slides"></swiper>
    </div>
  </div>
</template>
<script>
  import swiper from '../swiper/swiper'
  export default{
    data(){
      return {}
    },
    props: {
      slides:{
        type: Array
      },
      banner:{
        type:String
      }
    },
    methods: {},
    components:{
      swiper
    },
    mounted(){}
  }
</script>
<style type="text/scss" lang="scss" scoped>
  #headerTop {
    img{
      max-width: 100%;
      height: auto;
    }
    img[lazy=loading] {
      width: 20px;
      height: 20px;
      margin: 30px;
    }

  }
</style>



// WEBPACK FOOTER //
// header_pic.vue?2e14e69c